import { render, staticRenderFns } from "./ActionsPassport.vue?vue&type=template&id=3f1a9d64&"
import script from "./ActionsPassport.vue?vue&type=script&lang=js&"
export * from "./ActionsPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports